import { isAfter } from 'date-fns';
import isEqualTime from './isEqualTime';

const isSameOrAfter = (compareDate: Date, date: Date) => {
  return isAfter(compareDate, date) || isEqualTime(compareDate, date);
};

export default isSameOrAfter;
